"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var styleOverrides = {
    root: function(param) {
        var theme = param.theme;
        var _obj;
        return _obj = {
            color: theme.palette.default.dark,
            '&:hover': {
                backgroundColor: theme.palette.grey[100]
            }
        }, _define_property(_obj, "&.".concat(_material.radioClasses.checked), {
            color: theme.palette.default.dark
        }), _define_property(_obj, "&.".concat(_material.radioClasses.checked, ".").concat(_material.radioClasses.disabled), {
            color: theme.palette.grey[400]
        }), _obj;
    }
};
var defaultProps = {
    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.RadioButtonEmpty, {}),
    checkedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.RadioButtonChecked, {}),
    color: 'inputElements'
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiRadio.js.map
